export enum ColorModesType {
    auto = 'auto',
    light = 'light',
    dark = 'dark',
}